/* unplugin-vue-components disabled */import { render } from "./ai-action.vue?vue&type=template&id=eb702d2e&scoped=true"
import script from "./ai-action.vue?vue&type=script&lang=js"
export * from "./ai-action.vue?vue&type=script&lang=js"

import "./ai-action.vue?vue&type=style&index=0&id=eb702d2e&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb702d2e"],['__file',"src/components/ai-chat/ai-action.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb702d2e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb702d2e', __exports__)) {
    api.reload('eb702d2e', __exports__)
  }
  
  module.hot.accept("./ai-action.vue?vue&type=template&id=eb702d2e&scoped=true", () => {
    api.rerender('eb702d2e', render)
  })

}


export default __exports__